import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import customFetch from "../utils/customFetch";

export interface ServiceAuthToken {
    id: string;
    service_id: string;
    service_unique_id: string;
    service_readable_info: string;
    token_name?: string;
    access_token: string;
    refresh_token: string;
    token_type: string;
    expiry: string;
}

export const useGetServiceAuthTokensForService = (service?: string) => {
    return useQuery<ServiceAuthToken[], ErrorEvent>({
        queryKey: ['serviceAuthTokens', service],
        enabled: !!service,
        queryFn: () => {
            return customFetch(`/v1/service-auth-tokens?service=${service}`)
                .then(async(res) => {
                    const data = await res.json();
                    return res.ok
                        ? data
                        : Promise.reject(new Error(`Failed to fetch service auth tokens`))
                })
                .catch((err) => {
                    toast.error(err.message);
                    throw err;
                });
        }
    });
}; 